// src/utils/apiFetch.js

export const apiFetch = async (endpoint, options = {}) => {
    // 1. Injeta o token automaticamente em TODAS as requisições
    const token = localStorage.getItem('token');
    
    const headers = {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        ...options.headers
    };

    const config = { ...options, headers };

    // 2. Monta a URL base automaticamente (acaba com a necessidade de importar o API_URL em toda página)
    const API_URL = process.env.REACT_APP_API_URL || '';
    const url = endpoint.startsWith('http') ? endpoint : `${API_URL}${endpoint}`;

    try {
        const response = await fetch(url, config);

        // 3. O INTERCEPTADOR DE SEGURANÇA (O Padrão Ouro)
        if (response.status === 401 || response.status === 403) {
            console.warn("🔒 Sessão expirada ou acesso negado. Deslogando...");
            
            // Limpa dados sensíveis da memória por segurança (LGPD)
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('lancamentoVisitData'); 
            
            // Expulsa para o login de forma limpa
            window.location.href = '/login?session_expired=true';
            
            // Rejeita a promessa para parar imediatamente a execução do código no componente
            return Promise.reject(new Error('Sessão expirada'));
        }

        return response;
    } catch (error) {
        console.error('🌐 Erro de Rede ou API:', error);
        throw error;
    }
};